export default __webpack_public_path__ + "static/media/X.fd89f4bd.svg";